import Vue from "vue";
import App from "./App.vue";
import { router } from "@/router/router";
import { store } from "@/store/store";
import "./assets/styles/main-style.css";
import './foreGroundMessage'

router.beforeEach((to, from, next) => {

    const user = localStorage.getItem('newNXTSelfcareUser') ? localStorage.getItem('newNXTSelfcareUser') : '';

    if (to.fullPath !== '/' && !to.fullPath.includes('instantpayment') && !to.fullPath.includes('qrscan') && !to.fullPath.includes('ottquickpay') && !to.fullPath.includes('hdupgrade') && !to.fullPath.includes('paymentstatuscheck') && to.fullPath !== "/maintenance" && to.fullPath !== "/maintenancelogin" && !user) next('/')
    else next()
})

Vue.filter('getStringellips', (data) => {
    if(data) {
        return data;
    } 
    return '---'
})

const vueMain = new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});

export default vueMain;


// WEBPACK FOOTER //
// ./src/main.js